export default "/assets/images/hi-mila-black.webp?13c0f821f7b63eeb3423320689f65ce0";